export default "__VITE_ASSET__Bg0Em$Mt__"